import axios from "axios";

// The server questions a purchase that repeats a supplier invoice already
// recorded for the same material with a 409 carrying
// details.code = "duplicate_invoice" (the same bill logged twice doubles the
// supplier's bill and the stock). Returns true when that is the error, so the
// form can offer "it is a second delivery"; the message itself says which
// entry it repeats.
export function isDuplicateInvoice(err: unknown): boolean {
  if (!axios.isAxiosError(err) || err.response?.status !== 409) return false;
  const details = (err.response.data as { details?: { code?: string } } | undefined)?.details;
  return details?.code === "duplicate_invoice";
}
